import React from 'react';
import ClockNoPaddingIcon from '@shared/assets/icons/v2/clock-no-padding.svg';
import { MBView } from '@shared/components/MBView';
import { MBIcon } from '@shared/components/image';
import { MBText } from '@shared/components/text';
import { Styles } from './styles';

interface MBUrgentBadgeProps {
  /*
        What direction should the badge "float" to?
    */
  align: 'left' | 'right';
}

export function MBUrgentBadge({ align }: MBUrgentBadgeProps) {
  return (
    <MBView
      row
      center
      wrap
      style={[Styles.urgentBadge, align === 'right' && Styles.urgentBadgeAlignRight]}
    >
      <MBIcon noPadding color="white" style={Styles.urgentIcon} source={ClockNoPaddingIcon} />
      <MBText color="white" size="tiny" style={Styles.urgentText}>
        Urgent
      </MBText>
    </MBView>
  );
}
